export default __webpack_public_path__ + "static/squiseat-video-founder-e6b83112c555a0c041863f9ebc8aedbe.mp4";